import { createStore } from 'vuex'

export default createStore({
  state: {
    isLoggedIn:false,//是否登录
    isMobile:false,//是否是移动端
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
